module.exports = __webpack_public_path__ + "img/prod-4.ded58f85.png";